var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "logo-a",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 34,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.302 15.062 20.5 34.777c-.17.213-.256.32-.359.358a.4.4 0 0 1-.28 0c-.103-.039-.189-.145-.36-.358L3.7 15.062c-.107-.134-.16-.2-.183-.275a.4.4 0 0 1-.007-.203c.017-.076.066-.147.164-.287l3.809-5.48a.832.832 0 0 1 .053-.072.4.4 0 0 1 .042-.042.829.829 0 0 1 .072-.052l3.951-2.664a.832.832 0 0 1 .076-.048.398.398 0 0 1 .055-.024c.02-.007.043-.012.087-.022L15.796 5a.833.833 0 0 1 .07-.013.855.855 0 0 1 .042-.002L20 4.8l4.094.184.042.002a.42.42 0 0 1 .028.004l.041.009 3.977.894c.044.01.066.015.087.022a.397.397 0 0 1 .055.024c.02.01.039.023.076.048l3.95 2.664a.799.799 0 0 1 .073.052.677.677 0 0 1 .095.114l3.81 5.48c.097.14.146.21.163.287a.399.399 0 0 1-.007.203c-.022.074-.076.141-.183.275Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 .2H0v40h40V.2Z",
    fill: "#7EC7FF",
    style: {
      mixBlendMode: "hue"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.797 4.614h26.409v7.09H6.796v-7.09Z",
    fill: "#7EC7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20 11.704 5.282 5.784H14.72L20 11.704Z",
    fill: "#75C1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.869 10.024-5.47 4.665 4.904 1.213.566-5.877Z",
    fill: "#7AC6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.718 11.33-6.413 4.572 6.413 1.586V11.33Zm10.563 0 6.414 4.572-6.414 1.586V11.33Z",
    fill: "#8FCEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m8.305 15.902 6.413-4.571-5.847-1.306-.566 5.877Zm23.39 0L25.28 11.33l5.848-1.306.566 5.877Z",
    fill: "#47A9F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m31.129 10.024 5.47 4.665-4.904 1.213-.566-5.877Z",
    fill: "#7AC6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m7.548 8.719-4.15 5.97 5.47-4.664-1.32-1.306Zm24.902-.001 4.15 5.971-5.471-4.665 1.32-1.306Zm4.15 5.972L20 35.4l5.282-17.912L36.6 14.689Zm-33.202-.001 16.6 20.711-5.281-17.912-11.319-2.799Z",
    fill: "#47A9F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.398 14.69 19.055 35.4 8.303 15.902l-4.905-1.213Zm33.2 0L20.941 35.4l10.753-19.498 4.904-1.213Z",
    fill: "#309FF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.719 17.488 20 38.012l5.281-20.524H14.72Z",
    fill: "#8DCCFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m20 17.488-3.097 8.49-2.184-8.49H20Zm0 0 3.097 8.49 2.185-8.49H20Z",
    fill: "#BFE2F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.719 17.488V11.33l5.282.373-5.282 5.784Z",
    fill: "#99D1FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.282 17.488V11.33L20 11.704l5.282 5.784Z",
    fill: "#99D1FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.36 14.596 20 11.704l-5.281-.373 2.64 3.265Zm5.281 0L20 11.704l5.282-.373-2.641 3.265Z",
    fill: "#ADDCFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9abd1ed3.svg";
export { ForwardRef as ReactComponent };